module.exports = __webpack_public_path__ + "ab3fcfd67cab6372d2ea38562603295d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/help/help-phone.png
// module id = 464
// module chunks = 0